import React from 'react';
import ReactDOM from 'react-dom/client'
import {BrowserRouter as Router} from 'react-router-dom'
import store from './core/store'
import {Provider} from 'react-redux'
import App from "./components/App/App"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
)
